import React from "react";
import { Route, Routes } from "react-router-dom";
import Navbar from "../components/NavigationBar";
import EditEvent from "../pages/EditEvent/EditEvent";
import EventManager from "../pages/EventManager/EventManager";
import NewEvent from "../pages/NewEvent";
import EditEventData from "../pages/EditEventData";
import CSVExportPage from "../pages/CSVExport";
import CSVImporter from "../pages/CSVImporter";

const EventManagerRoutes = () => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route index element={<EventManager />} />
        <Route path="new" element={<NewEvent />} />
        <Route path="edit/:id" element={<EditEvent />} />
        <Route path="edit/:id/data" element={<EditEventData />} />
        <Route path="csv-export/:id" element={<CSVExportPage />} />
        <Route path="csv-import/:id" element={<CSVImporter />} />
        <Route path="*" element={<p> No Match </p>} />
      </Routes>
    </>
  );
};

export default React.memo(EventManagerRoutes);
